/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
//import { Link } from "react-router-dom";
import { useState } from "react";
import Tipo from "./Tipo";
import Horarios from "./Horarios";
import Imagenes from "./Imagenes";
import Precio from "./Precio";
//import Descuentos from "./Descuentos";
import { FORMs } from "../../../../conts/Property";
import { useNavigate, useParams } from "react-router-dom";
import { myHeaders } from "../../../../config/axios";
import { URL_API } from "../../../../config/default";
import { useQuery } from "@tanstack/react-query";
import { CustomToast } from "../../../../utils/custom-toast";
import Descripcion from "./Descripcion";
import Actividad from "./Actividad";

const EditarExcursion = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>(FORMs.EXCURSION);

  const onClick = async (e: any, property: any) => {
    switch (e.target.name) {
      case "save":
        {
          let formdata = new FormData();

          Object.keys(form).map((key: any) => {
            if (key != "id" && key != "owner_id" && key != "IMAGES") {
              if (
                key != "price" &&
                key != "DESCRIPTION_EXCURSION" &&
                key != "ACTIVITIES" &&
                key != "AMENITIES" &&
                key != "IMAGES" &&
                form[key] !== ""
              ) {
                formdata.append(key, form[key]);
              }

              if (
                key == "price"
              ) {
                formdata.append(key, String(form[key]));
              }

              if (
                key == "DESCRIPTION_EXCURSION" ||
                key == "ACTIVITIES" ||
                key == "AMENITIES"
              ) {
                if (form[key] !== null && form[key].length > 0) {
                  formdata.append(key, JSON.stringify(form[key]));
                }
              }

            }
          });

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/excursions/${property.id}`, requestOptions)
            .then(async (response) => {
              //const property = await response.json();

              if (response.ok) {
                CustomToast({
                  status: 200,
                  msg: "",
                  title: "Excursion editado con exito",
                });

                navigate("/publicaciones");
              } else {
                CustomToast({
                  status: 400,
                  msg: "",
                  title: "Ocurrio un error vuelve a internarlo",
                });
              }
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
    }
  };

  const { isPending, error, data } = useQuery({
    queryKey: ["excursion"],
    queryFn: async () => {
      return fetch(`${URL_API}/excursions/${slug}`).then(async (res) => {
        const response = await res.json();

        setForm({
          ...form,
          id: response.data.id,
          owner_id: response.data.owner_id,
          slug: response.data.slug,

          title: response.data.title,
          description: response.data.description ?? '',
          description_long: response.data.description_long ?? '',
          space: response.data.space,

          start_date: response.data.start_date,
          regular_time: response.data.regular_time,
          //'Flexible'--
          type_time: response.data.regular_time,
          duration: response.data.regular_time,

          price: response.data.price,
          status: response.data.status,
          DESCRIPTION_EXCURSION: response.data.description_excursion,
          ACTIVITIES: response.data.activities,
          AMENITIES: response.data.amenities,
          IMAGES: response.data.images,
          DATES: response.data.dates,
        });
        return response;
      });
    },
  });

  if (isPending) return "Loading...";

  if (error) {
    navigate("/404");
    return null;
  }

  if (!data || !data.data) {
    navigate("/404");
    return null;
  }

  const property = data.data;

  return (
    <div className="mx-auto w-full md:w-[80%]  min-h-max py-7 md:px-3 px- bg-white rounded-lg shadow-sm border">
      <span className="text-primary font-bold text-4xl block mb-5">
        Edita tu excursion
      </span>
      <div className="py-5">
        <Imagenes setForm={setForm} form={form} />
        <Descripcion setForm={setForm} form={form} />
        <Precio setForm={setForm} form={form} />
        <Actividad setForm={setForm} form={form} />
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <Tipo setForm={setForm} form={form} />
          <Horarios setForm={setForm} form={form} />
        </div>
        {/*<Bloqued setForm={setForm} form={form} /> */}
        {/*<Descuentos setForm={setForm} form={form} />*/}
      </div>

      <div
        className="sticky w-full bg-white py-5"
        style={{ zIndex: 2, bottom: "0px" }}
      >
        <div className="flex justify-between">
          <label
            className="bg-[#8B9456] px-6 py-3 text-white cursor-pointer text-center w-[150px] ms-2"
            style={{ borderRadius: "20px" }}
          >
            Cancelar
            <button
              className="hidden"
              onClick={() => navigate("/alquileres")}
            ></button>
          </label>

          <label
            className="bg-[#8B9456] px-6 py-3 text-white cursor-pointer"
            style={{ borderRadius: "20px" }}
          >
            Actualizar datos
            <button
              className="hidden"
              name="save"
              onClick={(event) => onClick(event, property)}
            ></button>
          </label>
        </div>
      </div>
    </div>
  );
};

export default EditarExcursion;
